'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _maxSafeInteger = require('babel-runtime/core-js/number/max-safe-integer');

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class;

var _Currency = require('../Currency');

var _tracksTransactions = require('../../utils/tracksTransactions');

var _tracksTransactions2 = _interopRequireDefault(_tracksTransactions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var EtherToken = (_class = function () {
  function EtherToken(web3Service, gasEstimatorService, transactionManager) {
    (0, _classCallCheck3.default)(this, EtherToken);

    this._web3 = web3Service;
    this._gasEstimator = gasEstimatorService;
    this._transactionManager = transactionManager;
  }

  // eslint-disable-next-line


  (0, _createClass3.default)(EtherToken, [{
    key: 'allowance',
    value: function allowance(tokenOwner, spender) {
      return _promise2.default.resolve(_maxSafeInteger2.default);
    }
  }, {
    key: 'balance',
    value: function balance() {
      return this.balanceOf(this._web3.currentAddress());
    }
  }, {
    key: 'balanceOf',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(owner) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _Currency.ETH;
                _context.next = 3;
                return this._web3.getBalance(owner);

              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt('return', _context.t0.wei.call(_context.t0, _context.t1));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function balanceOf(_x) {
        return _ref.apply(this, arguments);
      }

      return balanceOf;
    }()

    // eslint-disable-next-line

  }, {
    key: 'approve',
    value: function approve(spender, value) {
      return _promise2.default.resolve(true);
    }

    // eslint-disable-next-line

  }, {
    key: 'approveUnlimited',
    value: function approveUnlimited(spender) {
      return _promise2.default.resolve(true);
    }
  }, {
    key: 'transfer',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(toAddress, amount, options) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.transferFrom(this._web3.currentAddress(), toAddress, amount, options));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function transfer(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return transfer;
    }()
  }, {
    key: 'transferFrom',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(fromAddress, toAddress, amount, _ref4) {
        var _ref4$unit = _ref4.unit,
            unit = _ref4$unit === undefined ? _Currency.ETH : _ref4$unit,
            promise = _ref4.promise;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this._transactionManager.sendTransaction({
                  from: fromAddress,
                  to: toAddress,
                  value: (0, _Currency.getCurrency)(amount, unit).toFixed('wei')
                }, {
                  metadata: {
                    action: {
                      name: 'transfer',
                      from: fromAddress,
                      to: toAddress,
                      amount: (0, _Currency.getCurrency)(amount, unit)
                    }
                  },
                  promise: promise
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function transferFrom(_x5, _x6, _x7, _x8) {
        return _ref3.apply(this, arguments);
      }

      return transferFrom;
    }()
  }]);
  return EtherToken;
}(), (_applyDecoratedDescriptor(_class.prototype, 'transfer', [_tracksTransactions2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'transfer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'transferFrom', [_tracksTransactions2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'transferFrom'), _class.prototype)), _class);
exports.default = EtherToken;